<div class="inner-addon left-addon">
    <input type="text" class="form-control" [attr.placeholder]="placeholder" [value]="model" [formControl]="control">
    <span class="addon text-navy">
        <i class="fa" [ngClass]="{'fa-circle-o-notch fa-spin': loading, 'fa-search': !loading}"></i>
    </span>
</div>
